// extracted by mini-css-extract-plugin
export default {"featuredProducts":"FeaturedProducts_featuredProducts__B-cR0","top":"FeaturedProducts_top__bP-9j","bottom":"FeaturedProducts_bottom__TAlIJ"};